import { useTranslation } from 'react-i18next';
import { Button, ButtonVariant } from '../../ui/Button';
import styles from './Sync.module.css';

interface AccountHomeProps {
  /** The server address is not usable yet. */
  readonly disabled: boolean;
  readonly onLogin: () => void;
  readonly onRegister: () => void;
  readonly onForgot: () => void;
}

/** The account actions of the first screen: log in (primary), register, and the forgot-password link. */
export function AccountHome({ disabled, onLogin, onRegister, onForgot }: AccountHomeProps) {
  const { t } = useTranslation();
  return (
    <div className={styles.flow} data-testid="account-home">
      <div className={styles.actions}>
        <Button
          variant={ButtonVariant.Primary}
          disabled={disabled}
          onClick={onLogin}
          data-testid="account-login-start"
        >
          {t('sync.account.login')}
        </Button>
        <Button disabled={disabled} onClick={onRegister} data-testid="account-register-start">
          {t('sync.account.registerButton')}
        </Button>
      </div>
      <button
        type="button"
        className={styles.linkButton}
        disabled={disabled}
        onClick={onForgot}
        data-testid="account-forgot-start"
      >
        {t('sync.account.forgot')}
      </button>
    </div>
  );
}
